import { Model } from "infrontjs";

export class User extends Model
{
    static schema = {
        id: { type: 'string', default: null  },
        organisationId: { type: 'string', default: null },
        email: { type: 'string', transform: v => v?.toLowerCase() },
        role: { type: 'string', enum: ['user', 'admin', 'guest', 'root'], default: 'guest' },
        data: { type: 'object', default: null },
        settings: { type: 'object', default: null },
        createdAt: { type: 'datetime', default: null },
        updatedAt: { type: 'datetime', default: null }
    };

    static ROLE_NAMES = {
        user: 'Organisation member',
        admin: 'Organisation admin',
        root: 'System Root',
        guest: 'Guest'
    };

    static computed = {
        rolename: ( user ) => User.ROLE_NAMES[ user.role ] || user.role,
        isGuest : ( user ) => user.role === 'guest',
        name: ( user ) => user.data?.name
    };
};
